import React from 'react';
import useStoreToken from './StoreToken';
import { isAdmin } from './utils/appUtils';

/**
 * StoreToken wrapper factory that creates a StoreToken component
 * This eliminates code repetition between apps
 * 
 * @param {Object} config - Configuration object
 * @param {Function} config.useStateContext - Hook to get auth context
 * @param {Function} config.getBaseUrl - Function to get base URL
 * @param {Function} config.getIsAdmin - Optional function to check if admin (defaults to shared isAdmin)
 * @param {Function} config.getSendPosthogInfo - Optional function to send PostHog info
 * @returns {Function} StoreToken component
 */
export const createStoreTokenWrapper = (config) => {
  const {
    useStateContext,
    getBaseUrl,
    getIsAdmin = isAdmin,
    getSendPosthogInfo = () => {}
  } = config;

  const StoreToken = () => {
    const authContext = useStateContext();
    const { setuserDetails } = authContext;
    
    const { storeToLocal } = useStoreToken({
      baseUrl: getBaseUrl(),
      authContext,
      setuserDetails,
      isAdmin: getIsAdmin,
      sendPosthogInfo: getSendPosthogInfo
    });

    return {
      storeToLocal
    };
  };

  return StoreToken;
};

